import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormControlBase } from './form-models/form-control-base';

@Injectable()
export class DynamicFormControlService {

  constructor() { }

  setModel(model: any, controls: FormControlBase<any>[]) {
    if (!model || !controls) {
      return;
    }

    controls.forEach(control => {
      control.setModel(model);
    });
  }

  commit(controls: FormControlBase<any>[]) {
    if (!controls) {
      return;
    }

    controls.forEach(control => {
      if (control.visible) {
        control.commit();
      }
    });
  }

  toFormGroup(controls: FormControlBase<any>[]): FormGroup {
    const group: any = {};

    controls.forEach(control => {
      const formControl = this.createFormControl(control);
      group[control.key] = formControl;
      control.setFormControl(formControl, group);
    });

    return new FormGroup(group);
  }

  addControls(group: FormGroup, controls: FormControlBase<any>[]) {
    controls.forEach(control => {
      const formControl = this.createFormControl(control);
      control.setFormControl(formControl, group);
      group.addControl(control.key, formControl);
    });
  }

  private createFormControl(control: FormControlBase<any>): FormControl {
    return new FormControl({ value: control.value, disabled: control.disabled } || '');
  }
}
